import {useCallback, useState} from 'react';

import _ from 'topmeteo/utils/i18n';

import LightBox from 'topmeteo/general/components/LightBox';

import LocationManagerFavorites from './LocationManagerFavorites';
import LocationManagerHistory from './LocationMangagerHistory';
import LocationManagerHelpText from './LocationManagerHelpText';

const FavoritesHeading = _('Favorites');
const HistoryHeading = _('History');

const LocationManagerLightBox = ({onClose}) => {
    const [editing, setEditing] = useState(null);
    const handleEditChange = useCallback(
        location => setEditing(current => current === location ? null : location),
        [],
    );

    return (
        <LightBox className="location-manager" onClose={onClose}>
            <h1>{FavoritesHeading}</h1>
            <LocationManagerFavorites onSetEditable={handleEditChange} editing={editing} />
            <h1>{HistoryHeading}</h1>
            <LocationManagerHistory onSetEditable={handleEditChange} editing={editing} />
            <LocationManagerHelpText onClose={onClose} />
        </LightBox>
    );
};

export default LocationManagerLightBox;
